"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Briefcase;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Briefcase(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "General"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "briefcase"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "outline-4",
    "data-name": "outline",
    d: "M90,29.15H66.1v-10.7a2.5,2.5,0,0,0-2.5-2.5H36.4a2.5,2.5,0,0,0-2.5,2.5v10.7H10a2.5,2.5,0,0,0-2.5,2.5v49.9a2.5,2.5,0,0,0,2.5,2.5H90a2.5,2.5,0,0,0,2.5-2.5V31.65A2.5,2.5,0,0,0,90,29.15Zm-51.1-8.2H61.1v8.2H38.9Zm48.6,13.2V55.816h-75V34.15Zm-75,44.9V60.816H46.256v4.045a.5.5,0,0,0,.5.5h6.488a.5.5,0,0,0,.5-.5V60.816H87.5V79.051Z"
  }))));
}